module.exports = __webpack_public_path__ + "static/media/dropdown.c5758f37.svg";